import React, {Component} from "react";
import IntlMessages from "../../../../util/IntlMessages";
import {GetAccounts,searchAccount} from '../../../../appRedux/actions/accountAction';
import { updateAccountParent } from '../../../../appRedux/services/AccountService';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';
import ReactTable from "react-table";
import "react-table/react-table.css";
import CircularProgress from "../../../../components/CircularProgress";
import EditAccountForm from '../../../../Forms/EditAccountForm.js';
import SearchBox from '../../../../components/SearchBox';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import { ToastContainer, toast } from "react-toastify";
import {Table, Pagination, Icon, Select } from 'antd';
import { validParents, compareBy, buildFamilies, eligibleParents, parentOptionLabels, parentOptionDetails } from './accountHierarchy';
import moment from 'moment';
import "react-toastify/dist/ReactToastify.css";
import { Resizable } from 'react-resizable';
import "../../styles.css";
import "./AccountChartPage.css";

const ResizeableTitle = props => {
  const { onResize, width, ...restProps } = props;

  if (!width) {
    return <th {...restProps} />;
  }

  return (
    <Resizable width={width} height={0} onResize={onResize}>
      <th {...restProps} />
    </Resizable>
  );
};

class AccountChartPage extends Component {
    constructor(props) {
        super(props);
        let column = [{
            title: 'Account Number',
            dataIndex: 'accountNumber',
            className:'table-heading',
            sorter:  true,
            width:150
        },{
            title: 'Name',
            dataIndex: 'name',
            className:'table-heading',
            sorter:  true,
            width:350,
            render: (text, record) => this.renderName(text, record)
        },{
            title: 'Account Type',
            dataIndex: 'accountType',
            className:'table-heading',
            sorter:  true,
            width:180
        },{
          title: 'Last Reconciled',
          dataIndex: 'lastReconciledTransactionDate',
          className:'table-heading',
          sorter:  true,
          width:150,
          render: text => text!=null?<span title={moment(text).format("LL")}>
          {moment(text).format("L")}
        </span>:'',
      },{
        title: 'Reconciled Through',
        dataIndex: 'reconciledThrough',
        className:'table-heading',
        sorter:  true,
        width:200,
        render: text => text!=null?<span title={moment(text).format("LL")}>
          {moment(text).format("L")}
        </span>:'',
    },{
      title: 'Review Status',
      dataIndex: 'reviewStatus',
      className:'table-heading',
      sorter:  true,
      width:160
  },{
      title: 'Parent Account',
      dataIndex: 'parentAccount',
      className:'table-heading',
      width:240,
      // Anything in this cell, padding included, must not open the edit dialog.
      onCell: () => ({ onClick: (e) => e.stopPropagation(), onDoubleClick: (e) => e.stopPropagation() }),
      render: (text, record) => this.renderParentSelect(record)
  }
        ];
        this.state = {
            parentPicked:{},
            parentSaving:{},
            parentAwaiting:{},
            parentOpen:null,
            pageSize:50,
            currentPage:1,
            totalRowsInTable:0,
            fieldName:'accountId',
            sortFormat:'A',
            columns:column,
            accountsData:[],
            loading:true,
            searchText:'',
            search:false,
            selectedAccount:'',
            isOpen:false,
            isAddOpen:false,
            isEdit:false,
            companyId:'',
            collapsed:{}
        }
    }
    // The parent list is drawn in the page body (the table's scroll wrapper would clip it), so it must close when the page or table scrolls.
    setParentOpen = (accountID) => {
      this.setState({ parentOpen: accountID });
      window.removeEventListener('scroll', this.onParentScroll, true);
      if (accountID !== null) window.addEventListener('scroll', this.onParentScroll, true);
    }
    onParentScroll = (e) => {
      if (e.target && e.target.closest && e.target.closest('.chart-accounts-parent-dropdown')) return;
      this.setParentOpen(null);
    }
    componentWillUnmount() {
      window.removeEventListener('scroll', this.onParentScroll, true);
    }
    componentDidMount() {
       this.listData();
    }
    listData()
    {
      let user = JSON.parse(localStorage.getItem('userData'));
      const CompanyId = user.companyId;
      this.setState({companyId:user.companyId})
      // The whole chart loads once; grouping under parents, sort, search and paging run in the browser.
      this.props.GetAccounts(CompanyId,'',1,5000,'accountId','A');
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.accounts.data!==undefined && nextProps.accounts.data !== this.state.accountsData){
        // The reloaded list is here: stop holding the parents just saved.
        const awaiting = this.state.parentAwaiting || {};
        const picked = { ...this.state.parentPicked };
        Object.keys(awaiting).forEach((k) => { delete picked[k]; });
        this.setState({loading:false, accountsData:nextProps.accounts.data, parentPicked:picked, parentAwaiting:{}});
        }
        if(nextProps.reload==true)
          this.listData();
    }
    handleCancel = () => {
        this.setState({isOpen:false,isEdit:false});
    };

    handleAddModel = () => {
        this.setState({isAddOpen:true,isEdit:false});
    }

    handleEditModal= (record) =>{
        var id=record.key
        var data=this.state.accountsData;
       
        if(id!=0)
         {
            const selectedAccount = _.find( data, {accountID:id});
            
            this.setState({
                selectedAccount:selectedAccount,
                isEdit:true,
            });
        }

    }

    handleChange = (text) => {
      this.setState({ searchText: text || '', currentPage: 1 });
    }
    handleSave = (state) => {
        this.setState({
            isOpen:state,
            isEdit:state
        });
    }
    handleTableChange = (pagination, filters, sorter) => {
      if(sorter.order)
      {
        this.setState({ fieldName: sorter.field, sortFormat: sorter.order == "ascend" ? "A" : "D" });
      }
      else
      {
        this.setState({ fieldName: "accountId", sortFormat: "A" });
      }
    }
    onShowSizeChange(current, pageSize) {
      this.setState({ currentPage: current, pageSize: pageSize });
    }
    toggleCollapsed = (listId) => {
      this.setState((state) => ({ collapsed: { ...state.collapsed, [listId]: !state.collapsed[listId] } }));
    }
    // Sub-accounts are shown by shifting the name to the right; a parent gets an expand / collapse arrow.
    renderName = (text, record) => {
      const depth = record.__depth || 0;
      const searching = (this.state.searchText || '').trim() !== '';
      const collapsed = !searching && record.listID && this.state.collapsed[record.listID];
      return (
        <span className="chart-accounts-name" style={{ paddingLeft: depth * 20 }}>
          {this.hasHierarchy && (
            <span className="chart-accounts-toggle">
              {record.__childCount > 0 && record.listID && (
                <Icon
                  type={collapsed ? 'right' : 'down'}
                  onClick={(e) => { e.stopPropagation(); this.toggleCollapsed(record.listID); }}
                  onDoubleClick={(e) => e.stopPropagation()}
                />
              )}
            </span>
          )}
          {text}
        </span>
      );
    }
    // Choose a parent, then Save pushes it to QuickBooks. Nothing is sent until Save.
    saveParent = (record, parentListId) => {
      const key = record.accountID;
      this.setState((st) => ({ parentSaving: { ...st.parentSaving, [key]: true } }));
      updateAccountParent(record.companyID, record.accountID, parentListId)
        .then((res) => {
          const body = res && res.data;
          if (body && body.transactionStatus !== 0) {
            toast.error(body.resultMsg || 'Unable to update the parent account.');
            return;
          }
          toast.success('Parent account updated.');
          this.setState((st) => ({ parentAwaiting: { ...st.parentAwaiting, [key]: true } }));
          this.listData();
        })
        .catch(() => toast.error('Unable to update the parent account. Please refresh and try again.'))
        .then(() => this.setState((st) => ({ parentSaving: { ...st.parentSaving, [key]: false } })));
    }
    renderParentSelect = (record) => {
      const NO_PARENT = '__none__';
      const parentOf = this.parentOf || new Map();
      const all = this.allAccounts || [];
      const current = (record.listID && parentOf.get(record.listID)) || '';
      const picked = this.state.parentPicked[record.accountID] !== undefined ? this.state.parentPicked[record.accountID] : current;
      const saving = !!this.state.parentSaving[record.accountID];
      const awaiting = !!this.state.parentAwaiting[record.accountID];
      const options = eligibleParents(record, all, parentOf);
      const currentAccount = current && !options.some((o) => o.listID === current) ? all.find((o) => o.listID === current) : null;
      const shown = currentAccount ? [currentAccount].concat(options) : options;
      const labels = parentOptionLabels(shown);
      const details = parentOptionDetails(shown, all, parentOf);
      const setPicked = (value) => this.setState((st) => ({ parentPicked: { ...st.parentPicked, [record.accountID]: value } }));
      return (
        <span onClick={(e) => e.stopPropagation()} onDoubleClick={(e) => e.stopPropagation()}>
          <Select
            className="chart-accounts-parent-select"
            dropdownClassName="chart-accounts-parent-dropdown"
            value={picked || NO_PARENT}
            showSearch
            optionFilterProp="title"
            optionLabelProp="label"
            disabled={saving || awaiting || record.isActive === false}
            dropdownMatchSelectWidth={false}
            // Right edge of the list lines up with the select, so a wide list grows to the left instead of off the page.
            dropdownAlign={{ points: ['tr', 'br'], offset: [0, 4], overflow: { adjustX: 0, adjustY: 1 } }}
            open={this.state.parentOpen === record.accountID}
            onDropdownVisibleChange={(visible) => this.setParentOpen(visible ? record.accountID : null)}
            onChange={(v) => setPicked(v === NO_PARENT ? '' : v)}
          >
            <Select.Option key={NO_PARENT} value={NO_PARENT} label="None" title="None">None</Select.Option>
            {shown.map((o) => (
              <Select.Option key={o.listID} value={o.listID} label={labels.get(o.listID)} title={labels.get(o.listID)}>
                <span className="chart-accounts-parent-name">{labels.get(o.listID)}</span>
                <span className="chart-accounts-parent-detail">{details.get(o.listID)}</span>
              </Select.Option>
            ))}
          </Select>
          {picked !== current && !awaiting && (
            <span className="chart-accounts-parent-actions">
              <Button size="small" variant="contained" className="chart-accounts-parent-save" disabled={saving} onClick={() => this.saveParent(record, picked)}>{saving ? 'Saving…' : 'Save'}</Button>
              <Button size="small" variant="outlined" className="chart-accounts-parent-cancel" disabled={saving} onClick={() => setPicked(undefined)}>Cancel</Button>
            </span>
          )}
        </span>
      );
    }
  handleResize = index => (e, { size }) => {
    this.setState(({ columns }) => {
      const nextColumns = [...columns];
      nextColumns[index] = {
        ...nextColumns[index],
        width: size.width,
      };
      return { columns: nextColumns };
    });
  }

    render() {
      const { searchText } = this.state;
      const columns = this.state.columns.map((col, index) => ({
        ...col,
        onHeaderCell: column => ({
          width: column.width,
          onResize: this.handleResize(index),
        }),
      }));
      const components = {
        header: {
          cell: ResizeableTitle,
        },
      };

      // Families = a top-level account with its sub-accounts; pages hold whole families.
      const accounts = this.state.accountsData || [];
      const parentOf = validParents(accounts);
      this.parentOf = parentOf;
      this.allAccounts = accounts;
      this.hasHierarchy = parentOf.size > 0;
      const searching = (searchText || '').trim() !== '';
      const families = buildFamilies(accounts, parentOf, searchText, compareBy(this.state.fieldName, this.state.sortFormat));
      const totalFamilies = families.length;
      const lastPage = Math.max(1, Math.ceil(totalFamilies / this.state.pageSize));
      const currentPage = Math.min(this.state.currentPage, lastPage);
      const filteredData = [];
      families.slice((currentPage - 1) * this.state.pageSize, currentPage * this.state.pageSize).forEach((family) => {
        let hideBelow = Infinity;
        family.forEach((row) => {
          if (row.depth > hideBelow) return;
          hideBelow = Infinity;
          filteredData.push({ key: row.account.accountID, ...row.account, __depth: row.depth, __childCount: row.childCount });
          if (!searching && row.account.listID && this.state.collapsed[row.account.listID]) hideBelow = row.depth;
        });
      });
        return (
            <div className="chart-accounts-page">
              <EditAccountForm
                    isEdit={this.state.isEdit}
                    handleSave={this.handleSave}
                    visible={this.state.isEdit}
                    handleCancel={this.handleCancel}
                    selectedItem={this.state.selectedAccount}
                    accounts={accounts}
                    parentOf={parentOf}
                    reloadAccounts={() => this.listData()}
                    />
             {this.state.loading
              ?
               <div className="chart-accounts-loader">
                 <CircularProgress/>
               </div>
              :<React.Fragment>
             <div className="chart-accounts-header">
                   <h2 className="chart-accounts-title">Accounts</h2>
                <SearchBox
                   styleName="d-none d-lg-block"
                   placeholder="Search... "
                   value={searchText}
                   onChange= { (e) => {  this.handleChange(e.target.value) }}
                   style={{ background: '#eeeeeeb8'}}
                 />
             </div>
              <div className="chart-accounts-card">
              <div className="chart-accounts-table-wrap">
              <Table
                  className="table-layout"
                  columns={columns}
                  components={components}
                  dataSource={filteredData}
                  rowClassName={ (record) =>  this.state.selectedItemKey == record.key  ? 'data-row selected' : 'data-row'  }
                  bordered={true}
                  size={"small"}
                  onRow={(record, index) => ({
                    onClick: () => this.handleEditModal(record),
                    onDoubleClick: () => this.handleEditModal(record),
                  })}
                  onChange={this.handleTableChange}
                  loading={this.state.loading}
                  pagination={false}
                  />
              </div>
                  <div className="chart-accounts-pagination">
                  <Pagination
                  pageSizeOptions={['10','25','50','100']}
                  pageSize={this.state.pageSize}
                  showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                  showSizeChanger onChange={(a,b)=>this.onShowSizeChange(a,b)} onShowSizeChange={(a,b)=>this.onShowSizeChange(a,b)} current={currentPage} total={totalFamilies} />
                  </div>
              </div>
              </React.Fragment>
            }
            </div>
        );
    }
}

const mapStateToProps=(state)=>{
    return {
        accounts:state.accounts.accountsData,
        reload: state.accounts.reload,
    }
}
const mapDispatchToProps=(dispatch)=>{
    return bindActionCreators({
        GetAccounts,
        searchAccount,
    },dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(AccountChartPage);
